import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'

interface InvestorLayoutProps {
  children: React.ReactNode
}

export default function InvestorLayout({ children }: InvestorLayoutProps) {
  const navigate = useNavigate()
  const { user, logout } = useAuth()

  const handleLogout = () => {
    logout()
    navigate('/login')
  }

  return (
    <div className="investor-shell">
      <nav className="investor-nav">
        <div className="investor-nav-inner">
          <div className="investor-nav-brand">
            <img
              className="investor-nav-logo"
              src="https://www.martimart.com/assets/marti-favicon.png"
              alt="Martimart logo"
            />
            <span className="investor-nav-title">Martimart</span>
          </div>
          <div className="investor-nav-right">
            <span className="investor-nav-email">{user?.email}</span>
            <button onClick={handleLogout} className="investor-nav-logout">
              Sign out
            </button>
          </div>
        </div>
      </nav>
      <main className="investor-main">{children}</main>
    </div>
  )
}
